/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestGetUserListRequest
 */
export interface RequestGetUserListRequest {
    /**
     * 
     * @type {number}
     * @memberof RequestGetUserListRequest
     */
    baseId: number;
    /**
     * 
     * @type {number}
     * @memberof RequestGetUserListRequest
     */
    permissionId: number;
    /**
     * 
     * @type {number}
     * @memberof RequestGetUserListRequest
     */
    tenantId: number;
    /**
     * 
     * @type {number}
     * @memberof RequestGetUserListRequest
     */
    userId: number;
}

/**
 * Check if a given object implements the RequestGetUserListRequest interface.
 */
export function instanceOfRequestGetUserListRequest(value: object): value is RequestGetUserListRequest {
    if (!('baseId' in value) || value['baseId'] === undefined) return false;
    if (!('permissionId' in value) || value['permissionId'] === undefined) return false;
    if (!('tenantId' in value) || value['tenantId'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    return true;
}

export function RequestGetUserListRequestFromJSON(json: any): RequestGetUserListRequest {
    return RequestGetUserListRequestFromJSONTyped(json, false);
}

export function RequestGetUserListRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestGetUserListRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'baseId': json['base_id'],
        'permissionId': json['permission_id'],
        'tenantId': json['tenant_id'],
        'userId': json['user_id'],
    };
}

export function RequestGetUserListRequestToJSON(json: any): RequestGetUserListRequest {
    return RequestGetUserListRequestToJSONTyped(json, false);
}

export function RequestGetUserListRequestToJSONTyped(value?: RequestGetUserListRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'base_id': value['baseId'],
        'permission_id': value['permissionId'],
        'tenant_id': value['tenantId'],
        'user_id': value['userId'],
    };
}

